<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Platform / Action ticker</h1>
  </div>
</div>

<h2>Client</h2>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h3>In progress</h3>
    <div class="button-row">
      <ui-platform-action-ticker
        [role]="'client'"
        [state]="'in_progress'"></ui-platform-action-ticker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h3>Activated</h3>
    <div class="button-row">
      <ui-platform-action-ticker
        [role]="'client'"
        [state]="'activated'"></ui-platform-action-ticker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h3>Locked</h3>
    <div class="button-row">
      <ui-platform-action-ticker
        [role]="'client'"
        [state]="'locked'"></ui-platform-action-ticker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h3>Verified</h3>
    <div class="button-row">
      <ui-platform-action-ticker
        [role]="'client'"
        [state]="'verified'"
        [verificationValidationDate]="date"></ui-platform-action-ticker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h3>Expired</h3>
    <div class="button-row">
      <ui-platform-action-ticker
        [role]="'client'"
        [state]="'expired'"
        [verificationValidationDate]="date"></ui-platform-action-ticker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h3>Legacy</h3>
    <div class="button-row">
      <ui-platform-action-ticker
        [role]="'client'"
        [state]="'legacy'"></ui-platform-action-ticker>
    </div>
  </div>
</div>

<h2>Verifier</h2>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h3>In progress</h3>
    <div class="button-row">
      <ui-platform-action-ticker
        [role]="'verifier'"
        [state]="'in_progress'"></ui-platform-action-ticker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h3>Waiting</h3>
    <div class="button-row">
      <ui-platform-action-ticker
        [role]="'verifier'"
        [state]="'waiting'"></ui-platform-action-ticker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h3>Verify</h3>
    <div class="button-row">
      <ui-platform-action-ticker
        [role]="'verifier'"
        [state]="'verify'"></ui-platform-action-ticker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h3>Verified</h3>
    <div class="button-row">
      <ui-platform-action-ticker
        [role]="'verifier'"
        [state]="'verified'"
        [verificationValidationDate]="date"></ui-platform-action-ticker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h3>Expired</h3>
    <div class="button-row">
      <ui-platform-action-ticker
        [role]="'verifier'"
        [state]="'expired'"
        [verificationValidationDate]="date"></ui-platform-action-ticker>
    </div>
  </div>
</div>
